import { maintCheck } from './maint';

// frost drain check: drains, hydrants, air valves and irrigation filters
export const winterable = (f) => ['drain', 'hydrant'].includes(f.type) || ['EL', 'FI', 'BE'].includes(f.sym) || /filter|entleer|drain|svuot|vidang|purge/i.test(f.name || '');
const mark = (f, status, tag, winter) => { const m = maintCheck(f, status); m.maint.tags = [tag]; m.maintLog[0] = m.maint; return { ...m, winter }; };
export const winterPending = (f, t) => mark(f, 'warn', t.wiPending, 'pending');
export const winterDone = (f, t) => mark(f, 'ok', t.wiDone, 'done');
